import React, { useState } from 'react';
import { isMobile, isTablet } from 'react-device-detect';

import { SideIcon } from '../../../../components/icons';

import { AssetPreviewModal } from '../../../../components/modals';
import { fileDelete } from '../../../../services/api/files';
import { queuesDelete } from '../../../../services/api/queues';

import { File } from '../../../../types';
import { getFileImg } from '../../../../utils';

interface Props {
  img: File;
  allowDelete?: boolean;
  deletingPhotos: string[];
  setDeletingPhotos: React.Dispatch<React.SetStateAction<string[]>>;
  refetchData: any;
  isPublic?: boolean;
}

const PersonPhoto: React.FC<Props> = (props) => {
  const {
    img,
    allowDelete,
    deletingPhotos,
    setDeletingPhotos,
    refetchData,
    isPublic,
  } = props;

  const [showPreviewPhoto, setShowPreviewPhoto] = useState(false);

  // deletes photo and queues associated with it
  const handleDeletePhoto = async () => {
    if (!img.elementId) return;

    // add elementId to list of deleting photos
    setDeletingPhotos([...deletingPhotos, img.elementId]);

    await queuesDelete(img.elementId, isPublic);
    await fileDelete(img.elementId, isPublic);

    refetchData();
  };

  return (
    <div className="group relative w-20 h-20">
      {/* delete icon – shows X or spinner if deleting */}
      {allowDelete && !isMobile && !isTablet && (
        <SideIcon
          type="delete"
          deleteType="photo"
          isProcessing={deletingPhotos.includes(img.elementId ?? '')}
          onClick={handleDeletePhoto}
        />
      )}

      <img
        src={getFileImg(img)}
        className="w-full h-full object-cover rounded-full cursor-pointer"
        alt={img.name}
        onClick={() => setShowPreviewPhoto(true)}
      />

      <AssetPreviewModal
        show={showPreviewPhoto}
        onHide={() => setShowPreviewPhoto(false)}
        file={img}
        handleDeletePhoto={
          allowDelete
            ? async () => {
                await handleDeletePhoto();
                setShowPreviewPhoto(false);
              }
            : undefined
        }
      />
    </div>
  );
};

export default PersonPhoto;
